const initialState = {
  isAuthenticated: false,
  user: null,
  token: null,
  isInitialized: false,
  error: null
};

export const AUTH_ACTIONS = {
  SET_AUTH_STATE: 'SET_AUTH_STATE',
  SET_USER: 'SET_USER',
  SET_ERROR: 'SET_ERROR',
  LOGOUT: 'LOGOUT',
  SET_TOKEN: 'SET_TOKEN'
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_ACTIONS.SET_AUTH_STATE:
      return {
        ...state,
        isAuthenticated: action.payload,
        isInitialized: true
      };
    case AUTH_ACTIONS.SET_USER:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
        error: null
      };
    case AUTH_ACTIONS.SET_TOKEN:
      return {
        ...state,
        token: action.payload
      };
    case AUTH_ACTIONS.SET_ERROR:
      return {
        ...state,
        error: action.payload,
        isAuthenticated: false
      };
    case AUTH_ACTIONS.LOGOUT:
      return {
        ...initialState,
        isInitialized: true
      };
    default:
      return state;
  }
};

export default authReducer;
